import type { HTMLAttributes } from "react";
import { cn } from "../lib/utils";

type BadgeVariant = "default" | "secondary" | "destructive" | "outline";

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
}

export function Badge({ variant = "default", className, ...props }: BadgeProps) {
  return (
    <span className={cn("badge", `badge-${variant}`, className)} {...props} />
  );
}
